/**
 * Italian number formatting (A12 of /docs/design.md).
 *
 * Percentages: 2 decimals and a non-breaking space before `%`.
 * Numbers: Italian separators (1.234,56).
 */
const LOCALE = "it-IT";
const NBSP = "\u00A0";

/** Percentage from a fraction (0.0466 → "4,66 %"). */
export function formatPercent(fraction, { decimals = 2 } = {}) {
  if (fraction === null || fraction === undefined || Number.isNaN(Number(fraction))) return null;
  return formatPercentPoints(Number(fraction) * 100, { decimals });
}

/** Percentage from percentage points (4.66 → "4,66 %"). */
export function formatPercentPoints(points, { decimals = 2 } = {}) {
  if (points === null || points === undefined || Number.isNaN(Number(points))) return null;
  return `${Number(points).toLocaleString(LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}${NBSP}%`;
}

export function formatNumber(value, { decimals = 0 } = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
  return Number(value).toLocaleString(LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
